import { Loader, LoaderProps } from "@progress/kendo-react-indicators";
import * as styles from "./Loader.css.ts";

const CustomLoader = ({ type, ...props }: LoaderProps) => {
  return (
    <div className={styles.loaderContainer}>
      <Loader {...props} type={type} />
    </div>
  );
};

export default CustomLoader;
